import type { TypeOf } from './types/type-of.type';

/**
 * Checks if the type of the provided value matches any of the specified types.
 *
 * @param value - The value whose type is to be checked.
 * @param types - A rest parameter of types to check against (e.g., 'string', 'number', 'boolean').
 * @returns `true` if the type of `value` matches any of the provided types, otherwise `false`.
 */
export const isTypeOf = (value: unknown, ...types: TypeOf[]) => {
  return types.includes(typeof value as TypeOf);
};
